export type LanguageOption = { code: string; label: string };

export const BASE_LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'en', label: 'English' },
  { code: 'bg', label: 'Bulgarian' },
  { code: 'cs', label: 'Czech' },
  { code: 'da', label: 'Danish' },
  { code: 'de', label: 'German' },
  { code: 'el', label: 'Greek' },
  { code: 'et', label: 'Estonian' },
  { code: 'fi', label: 'Finnish' },
  { code: 'fr', label: 'French' },
  { code: 'ga', label: 'Irish' },
  { code: 'hr', label: 'Croatian' },
  { code: 'hu', label: 'Hungarian' },
  { code: 'es', label: 'Spanish' },
  { code: 'it', label: 'Italian' },
  { code: 'lt', label: 'Lithuanian' },
  { code: 'lv', label: 'Latvian' },
  { code: 'mt', label: 'Maltese' },
  { code: 'nl', label: 'Dutch' },
  { code: 'pl', label: 'Polish' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'ro', label: 'Romanian' },
  { code: 'sk', label: 'Slovak' },
  { code: 'sl', label: 'Slovenian' },
  { code: 'sv', label: 'Swedish' },
];

// All CLP-legislation languages are supported as a source/base language.
// The glossary database holds the official CLP statements for every code below,
// so SDS extraction and downstream translation work from any of these.
export const ENABLED_BASE_LANGUAGE_CODES: string[] = BASE_LANGUAGE_OPTIONS.map((opt) => opt.code);

export const getEnabledBaseLanguageOptions = (): LanguageOption[] =>
  BASE_LANGUAGE_OPTIONS.filter((opt) => ENABLED_BASE_LANGUAGE_CODES.includes(opt.code));

export const getDefaultBaseLanguage = (): string => getEnabledBaseLanguageOptions()[0]?.code ?? 'en';
